import React from 'react';
import LogoImg from '../../images/citizen.png';
import { FooterWrapper } from '../HelperComponents/StyledComponents';

export const Footer = () => (
  <FooterWrapper className="">
    <div className="container">
      <section className="columns is-mobile is-centered">
        <section className="column is-narrow">
          <figure className="image" style={{ width: '91px' }}>
            <img src={LogoImg} style={{ filter: 'brightness(0) invert(1)' }} alt="Citizen Footer Logo"/>
          </figure>
        </section>
      </section>
    </div>
  </FooterWrapper>
);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js